import styles from '@features/cms/components/categories/CategoryGalleryBlock/components/ListingHeader/ListingHeader.styles';
import Heading from '@components/Heading/Heading';
import sanitizeHtml from '@utils/sanitizeHtml';
type PropsType = {
  isFirst: boolean;
  allImagesCount: number;
  title: string;
  description: string;
  haveFilters: boolean;
};
const ListingHeader = ({
  isFirst,
  allImagesCount,
  title,
  description,
  haveFilters
}: PropsType) => <div sx={styles.headerContent(haveFilters)} data-testid="category-gallery-block-listing-header">
    <div sx={styles.titleWrapper} data-testid="category-gallery-block-listing-header-title-wrapper">
      <Heading h={isFirst ? 1 : 2} headingType={2} mobile dangerouslySetInnerHTML={sanitizeHtml(title)} />
      <div sx={styles.titleCount} data-testid="category-gallery-block-listing-header-title-count">
        ({allImagesCount})
      </div>
    </div>
    <p sx={styles.descriptionText} dangerouslySetInnerHTML={sanitizeHtml(description)} data-testid="category-gallery-block-listing-header-description" />
  </div>;
export default ListingHeader;